
import LocationSelector from '@/components/LocationSelector.vue'
import DebounceInput from '@/components/DebounceInput.vue'
import BasicTableComponent from '@/components/Table/BasicTableComponent.vue'
import ExportToExcel from '@/components/ExportToExcel.vue'

import GenericDatePeriodSelector from '@/components/GenericDataStoreComponents/GenericDatePeriodSelector.vue'
import GenericDaysSelector from '@/components/GenericDataStoreComponents/GenericDaysSelector.vue'
import GenericDaySelector from '@/components/GenericDataStoreComponents/GenericDaySelector.vue'
// This exports the plugin object.
export default {
  // The install method will be called with the Vue constructor as         
  // the first argument, along with possible options
  install (Vue, options) {
    Vue.component('LocationSelector', LocationSelector)
    Vue.component('BasicTableComponent', BasicTableComponent)
    Vue.component('DebounceInput', DebounceInput)
    Vue.component('ExportToExcel', ExportToExcel)
    Vue.component('GenericDatePeriodSelector', GenericDatePeriodSelector)
    Vue.component('GenericDaysSelector', GenericDaysSelector)
    Vue.component('GenericDaySelector', GenericDaySelector)
  }
}